import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";

import AppRoutes from "./AppRoutes";
import { MaterialUIControllerProvider } from "./context";
import theme from "./assets/theme";

const container = document.getElementById("root");

if (!container) {
  throw new Error('Root element with id="root" was not found.');
}

const root = ReactDOM.createRoot(container);

root.render(
  <React.StrictMode>
    <MaterialUIControllerProvider>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <BrowserRouter>
          <AppRoutes />
        </BrowserRouter>
      </ThemeProvider>
    </MaterialUIControllerProvider>
  </React.StrictMode>
);
